export default __webpack_public_path__ + "static/cast-7aba91ad4fd77aab643257648bd4d675.jpg";